module.exports = {
	"network": {
		"bind": "127.0.0.1:8333",
		"externalip": "your_tor_address.onion",
		"dns": 0,
		"dnsseed": 0,
		"listenonion": 1,
		"listen": 0,
		"onion": "127.0.0.1:9050",
		"onlynet": "onion",
		"proxy": "127.0.0.1:9050",
		"proxyrandomize": 1,
		"seednode": "hhiv5pnxenvbf4am.onion",
		"addnode": "h2vlpudzphzqxutd.onion",
		"torcontrol": "127.0.0.1:9051",
		"torpassword": ""
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/tor.json
 ** module id = 49
 ** module chunks = 0
 **/